<template>
  <nav class="main-menu">
    <div class="main-menu__links">
      <router-link :to="{name: 'root'}">Home</router-link>
      |
      <router-link :to="{name: 'maps'}">Maps</router-link>
    </div>
    <div class="main-menu__info" v-if="currentMap">
      Map: {{ currentMap.name }}
    </div>
  </nav>
</template>

<script>
export default {
  name: 'MainMenu',
  data () {
    return { currentMap: null }
  },
  methods: {
    setCurrentMap (id) {
      if (id === null) {
        this.currentMap = null
        return
      }

      this.currentMap = this.$store.getters.map(id)
    },
  },
  created () {
    this.setCurrentMap(this.$route.params.mapId)
  },
  watch: {
    '$route.params.mapId' (newValue) {
      this.setCurrentMap(newValue)
    },
  },
}
</script>
